export default "__VITE_ASSET__HbRH$Ocj__"